export const DOCUMENT_DRAFT_HANDLED = "DOCUMENT_DRAFT_HANDLED";
export const DOCUMENT_DRAFT_DELETED = "DOCUMENT_DRAFT_DELETED";
export const DOCUMENT_DRAFT_SNOOZED = "DOCUMENT_DRAFT_SNOOZED";
export const DOCUMENT_DRAFT_REMOVED_HANDLED = "DOCUMENT_DRAFT_REMOVED_HANDLED";
